import React from 'react'
import moment from 'moment';
import DateTimeField from 'react-bootstrap-datetimepicker'
import { t } from '../helpers/translate.js'

class TripCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: '',
      endDate: '',
      selectedOption: 'add',
      days: '',
      months: '',
      weeks: '',
      years: '',
      options: 'caldiff'
    };
  }

  handleStartDate(date) {
    this.setState({ startDate: date });
  }

  handleEndDate(date) {
    this.setState({ endDate: date });
  }

  handleActionChange(e) {
    this.setState({ selectedOption: e.target.value })
  }

  handleDaysChange(e) {
    this.setState({ days: e.target.value });
  }

  handleWeeksChange(e) {
    this.setState({ weeks: e.target.value });
  }

  handleMonthsChange(e) {
    this.setState({ months: e.target.value });
  }

  handleYearsChange(e) {
    this.setState({ years: e.target.value });
  }

  setRadioOption(e) {
    this.setState({
      options: e.target.value,
      endDate: '',
      days: '',
      months: '',
      weeks: '',
      years: '',
    });
  }

  getStartDate() {
    this.state.startDate ? this.state.startDate : '';
  }

  getEndDate() {
    this.state.endDate ? this.state.endDate : '';
  }

  renderRadioOptions() {
    return (<div className="row text-center" onChange={this.setRadioOption.bind(this)}>
      <div className="radio-inline radio-align">
        <input type="radio" value='caldiff' name="radio" id='caldiff' defaultChecked />
        <label className="email-option">{t('Calculate Duration')}</label>
      </div>
      <div className="radio-inline radio-align">
        <input type="radio" value='caldate' name="radio" id='caldate' />
        <label className="email-option">{t('Calculate New Date')}</label>
      </div>
    </div>)
  }

  displaydiffdays() {
    return (this.state.startDate && this.state.endDate && this.state.options == 'caldiff') &&
      (<div className="div-center col-md-10 col-sm-8">
        <div className="trip-result">
          <h3><strong>{t('Result:')} {`${Math.abs(moment(this.state.startDate).diff(moment(this.state.endDate), 'days')) + 1} Days`}</strong></h3>
        </div>
        <p>{t('This includes Start Date and End Date')}</p>
      </div>)
  }

  renderEndDate() {
    let dateFormat = 'YYYY-MM-DD';
    return this.state.options == 'caldiff' &&
      (<div className="col-md-3">
        <h4 className='text-uppercase'>{t('End Date')}</h4>
        <DateTimeField mode="date" size="md" inputFormat={dateFormat} format={dateFormat}
          dateTime={moment(this.getEndDate()).format(dateFormat)} defaultText={this.getEndDate() ? this.getEndDate() : ''}
          onChange={this.handleEndDate.bind(this)}
          inputProps={{ id: this.props.id, placeholder: 'YYYY-MM-DD' }}
        />
      </div>)
  }

  renderDays() {
    return this.state.options == 'caldate' &&
      <div>
        <div id="datecalc_type" className="col-md-2 trip-textbox">
          <h4 htmlFor="type">{t('Add/Subtract:')}</h4>
          <select id="type" name="type" className='form-control' value={this.state.selectedOption} onChange={this.handleActionChange.bind(this)}>
            <option value="add" defaultValue>(+) Add</option>
            <option value="sub">(–) Subtract</option>
          </select>
        </div>
        <div className="col-md-8">
          <div className="col-md-3">
            <h4 htmlFor="ay">{t('Years')}</h4>
            <input type="text" className='form-control' maxLength="4" size="4" id="ay" name="ay" onChange={this.handleYearsChange.bind(this)} />
          </div>
          <div className="col-md-3">
            <h4 htmlFor="am">{t('Months')}</h4>
            <input type="text" className='form-control' maxLength="4" size="4" id="am" name="am" onChange={this.handleMonthsChange.bind(this)} />
          </div>
          <div className="col-md-3">
            <h4 htmlFor="aw">{t('Weeks')}</h4>
            <input type="text" className='form-control' maxLength="4" size="4" id="aw" name="aw" onChange={this.handleWeeksChange.bind(this)} />
          </div>
          <div className="col-md-3 ">
            <h4 htmlFor="ad">{t('Days')}</h4>
            <input type="text" className='form-control' maxLength="4" size="4" id="ad" name="ad" onChange={this.handleDaysChange.bind(this)} />
          </div>
        </div>
      </div>
  }

  renderResultDate() {
    const date = moment(this.state.startDate);
    const startDate = (date.toDate()).toDateString();
    const contentKeys = { years: this.state.years, months: this.state.months, weeks: this.state.weeks, days: this.state.days };
    const changeAction = (this.state.selectedOption == 'add') ? date.add(contentKeys).subtract(1, 'days') : date.subtract(contentKeys).add(1, 'days');
    const resultDate = (changeAction.toDate()).toDateString();
    return (this.state.startDate && this.state.options == 'caldate' && (this.state.years || this.state.months || this.state.weeks || this.state.days)) &&
      <div className="div-center col-md-10">
        <div className="trip-result">
          <h3><strong>{t('Result:')} {`${resultDate}`}</strong></h3>
        </div>
        <p>{t('This is from Start Date:')} {`${startDate}`}</p>
      </div>
  }

  render() {
    let dateFormat = 'YYYY-MM-DD';
    return <div className="container">
      <div className="text-center page-title">
        <h2>{t('Trip Calculator')}</h2>
      </div>
      {this.renderRadioOptions()}
      <div className="row">
        <div>
          <div className="date-wrapper form-control-static col-md-12">
            <div className="col-md-3">
              <h4 className='text-uppercase'>{t('Start Date')}</h4>
              <DateTimeField mode="date" size="md" inputFormat={dateFormat} format={dateFormat}
                dateTime={moment(this.getStartDate()).format(dateFormat)} defaultText={this.getStartDate() ? this.getStartDate() : ''}
                onChange={this.handleStartDate.bind(this)}
                inputProps={{ id: this.props.id, placeholder: 'YYYY-MM-DD' }}
              />
            </div>
            <div className="col-md-4"></div>
            {this.renderEndDate()}
            {this.renderDays()}
          </div>
          {this.displaydiffdays()}
          {this.renderResultDate()}
        </div>
      </div>
    </div>
  }

}
TripCalculator.displayName = 'TripCalculator';
export default TripCalculator;


// WEBPACK FOOTER //
// ./src/components/TripCalculator.js